<template>
    <div class="product-price" itemscope itemprop="offers" itemtype="http://schema.org/Offer">
        <div class="product-badge-container">
            <span v-if="product.new" class="product-badge product-badge--new">New</span>
            <span v-if="codeApplied"
                  class="product-badge product-badge--promo">-{{ product.promo_code.discount }}</span>
            <span v-if="product.discount"
                  class="product-badge product-badge--sale">-{{ product.discount }}%</span>
            <product-bonus :product='product'></product-bonus>
        </div>

        <div class="product-price-container">
            <div itemprop="price"
                 :content="codeApplied ? parseInt(finalPrice) : parseInt(sellingPrice)"
                 class="product-price-total"
                 :class="[{ 'product-price-total--sale': product.discount || codeApplied, 'product-price-total--promo': codeApplied }]">
                {{ codeApplied ? $root.priceFormat(finalPrice) : $root.priceFormat(sellingPrice) }}<span class="rub"> руб</span>
            </div>
            <span v-if="codeApplied && product.discount" class="product-price-old product-price-old sale">
                {{ $root.priceFormat(sellingPrice) }}<span class="rub"> руб</span>
            </span>
            <span v-if="product.discount" class="product-price-old">{{ $root.priceFormat(product.price) }}<span
                class="rub"> руб</span></span>
            <span v-if="codeApplied && !product.discount" class="product-price-old">
                {{ $root.priceFormat(sellingPrice) }}<span class="rub"> руб</span>
            </span>
        </div>
        <promo-code v-if="product.promo_code" :product="product" @update="updateFinalPrice"></promo-code>
        <credit :price="price"/>
    </div>
</template>

<script>
import Credit from "./Credit.vue";
import {mapState} from "vuex";
import Template from "../AdminPanel/Content/TemplateForm.vue";

export default {
    name: 'ProductPrice',
    components: {Template, Credit},
    props: {
        product: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            sellingPrice: null,
            finalPrice: null
        }
    },
    created() {
        this.sellingPrice = this.product.selling_price;

        if (this.product.promo_code && this.product.promo_code.applied) {
            this.finalPrice = this.product.promo_code.final_price;
        }
    },
    methods: {
        updateFinalPrice(value) {
            this.finalPrice = value;
        }
    },
    computed: {
        codeApplied() {
            return this.finalPrice !== null;
        },
        price() {
            return this.finalPrice ? this.finalPrice : this.sellingPrice;
        },
    }
}
</script>
